<template>
	<div class="card">
        <h5>Edit Candidate</h5>
        <TabView>
            <TabPanel :header="$t('personal-info')">
                <PersonalInfo></PersonalInfo>
            </TabPanel>
            <TabPanel :header="$t('family-relation')">
                <Relative></Relative>
            </TabPanel>
            <TabPanel :header="$t('formal-education')">
                <Education></Education>
            </TabPanel>
            <TabPanel :header="$t('certification')">
                <Certification></Certification>
            </TabPanel>
            <TabPanel :header="$t('work-history')">
                <WorkHistory></WorkHistory>
            </TabPanel>
        </TabView>
    </div>
</template>
<script>
import AppLayout from "../../Layouts/AppLayout";
import InputText from "primevue/inputtext"
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import PersonalInfo from './Components/PersonalInfo';
import Relative from './Components/Relative';
import Education from './Components/Education';
import Certification from './Components/Certification';
import WorkHistory from './Components/WorkHistory';

export default {
    layout: AppLayout,
    components: { InputText, TabView, TabPanel, PersonalInfo, Relative, Education, Certification, WorkHistory},
}
</script>
